import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vice-principal',
  templateUrl: './vice-principal.component.html',
  styleUrls: ['./vice-principal.component.scss']
})
export class VicePrincipalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
